import React from 'react';

type Props = {
  children: React.ReactChild;
  renderError?: (...props: any[]) => React.ReactNode | null;
};
type State = {
  hasError: boolean;
};

export class ErrorBoundary extends React.Component<Props, State> {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    // You can also log the error to an error reporting service
    console.log('call ErrorBoundary');
    console.log(error, info);
  }

  render() {
    const { hasError } = this.state;
    const { renderError, children } = this.props;
    if (hasError) {
      if (renderError) {
        // You can render any custom fallback UI
        return renderError();
      }
      return <h1>Something went wrong.</h1>;
    }

    return children;
  }
}
